import { ReactNode, FC } from "react";
import Breadcrumb from "../atoms/Breadcrumb";
import PageController from "./PageController";

type PageHeaderProps = {
    title: string;
    breadcrumb: { label: string, url: string, onClick?: () => void }[];
    apiVersion: string;
    children: ReactNode;
    truncateTitle?: boolean;
}

const PageHeader: FC<PageHeaderProps> = ({ title, apiVersion, breadcrumb, children, truncateTitle = false }) => {
    // Converter url para path para o componente Breadcrumb
    const breadcrumbItems = breadcrumb.map(item => ({
        label: item.label,
        path: item.url !== '#' ? item.url : undefined,
        onClick: item.onClick,
    }));

    return (
        <div className="grid grid-cols-2 gap-2">
            <div className={`sticky top-0 z-10 ${truncateTitle ? 'min-w-0' : ''}`}>
                <Breadcrumb items={breadcrumbItems} />
                <h1
                    className={`${truncateTitle ? 'block truncate' : 'inline-block'} text-2xl text-primary dark:text-primary font-medium tracking-tight pt-2 pb-3`}
                    title={truncateTitle ? title : undefined}
                >
                    {title}
                </h1>

            </div>

            <PageController>
                <span className="absolute text-xs text-secondary dark:text-gray-400 mr-2">{apiVersion}</span>
                {children}
            </PageController>
        </div>
    );
};

export default PageHeader;